<template>
    <breadCrumbs title="Social App" title1="Social App" />
    <div class="container-fluid">
        <div class="user-profile social-app-profile text-start">
            <div class="row">
                <socialHeader />
            </div>
        </div>
    </div>
</template>
<script>

import socialHeader from "./socialHeader.vue"
export default {
    components: {
        socialHeader
    }
}
</script>